module.exports = __webpack_public_path__ + "media/components/assets/icons/close_sm-c6198d470db767800f07160133014ea5.svg";